/**
 * Created by Jiu Chen on 01/11/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';

import { TeamsActionTypes } from '../actions/teams.actions';
import { EntryService } from '@tamalelibs/services/entry.service';

@Injectable()
export class TeamsEffects {

    constructor(
        private _actions$: Actions,
        private _entryService: EntryService,
    ) { }

    initializeEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(TeamsActionTypes.INITIALIZE),
        switchMap(() => {
            return this._entryService.getAllTeams().pipe(
                map(response => response['team-list']),
                map(response => {
                    const teamList = response.map(element => {
                        return {
                            id: element.id,
                            name: element['long-name'],
                            shortName: element['short-name'],
                            aliases: element['aliases'].data.map(item => item.data.name)
                        };
                    });
                    return {
                        type: TeamsActionTypes.INITIALIZE_SUCCESS,
                        payload: teamList
                    };
                })
            );
        })
    ));
}
